import * as React from "react";
import { RenameHashTagForm } from "source/app/presentation/MainPanel/Dreams/HashTagOptions/Rename/RenameHashTagForm";
import { RemoveHashTagLink } from "source/app/presentation/MainPanel/Dreams/HashTagOptions/Remove/RemoveHashTagLink";

export function HashTagOptions({ hashTag }: { hashTag: string }) {
    return (
        <div>
            <div>
                Selected hashtag is <strong>{hashTag}</strong>
            </div>
            <RenameHashTagForm {...{ hashTag }} />
            <RemoveHashTagLink {...{ hashTag }} />
        </div>
    );
}
